var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPerp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7127 29.1129C17.249 29.5717 16.6339 29.8021 16.0169 29.8005C15.4034 29.8008 14.7914 29.5706 14.3302 29.1131C11.5347 26.3404 8.65353 23.6434 5.77638 20.95L5.77631 20.95L5.77623 20.9499C4.35332 19.6179 2.93139 18.2868 1.52128 16.948C-0.241142 15.2746 -0.241145 12.5271 1.52128 10.8537L9.34968 3.4209C11.0649 1.79232 13.8114 1.79232 15.5266 3.4209L19.6001 7.28851L20.0878 6.82494C21.7987 5.19658 24.5381 5.19658 26.249 6.82494L30.4818 10.8536C32.24 12.527 32.24 15.2747 30.4818 16.9481C29.1028 18.2606 27.7143 19.5668 26.325 20.8737L26.325 20.8737C23.4315 23.5956 20.5347 26.3207 17.7127 29.1129ZM19.5371 13.7645L19.385 13.909L23.1684 17.5099L26.9604 13.9008L23.1684 10.2918L23.0309 10.4227C22.4826 10.9445 21.939 11.4661 21.3957 11.9874L21.3955 11.9876L21.3952 11.9879C20.7775 12.5806 20.1603 13.1728 19.5371 13.7645ZM8.8529 17.5097L16.2317 10.4897L12.4382 6.88789L5.05198 13.9008L8.8529 17.5097ZM19.8065 20.7096L16.0273 17.097L12.2228 20.7093L16.0193 24.314L19.8065 20.7096Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPerp);
export default __webpack_public_path__ + "static/media/logo-perp.248ed17dbf0af5becde4d63139c735be.svg";
export { ForwardRef as ReactComponent };